import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderNav,
  CHeaderToggler,
  CNavItem,
  CFormSelect,
  CButton,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilMenu } from '@coreui/icons'
import AppHeaderDropdown from './AppHeaderDropdown'
import { GlobalContext } from 'src/views/context/GlobalState'
import { AppContext } from 'src/views/context/app'
import { isEmpty } from 'lodash'
import { raiseToast } from 'src/views/utils/helper'

const AppHeader = () => {
  const dispatch = useDispatch()
  const sidebarShow = useSelector((state) => state.nav.sidebarShow)
  const language = localStorage.getItem('language')
  const { userObj } = useContext(GlobalContext)
  const { accountObj } = useContext(AppContext)

  const changeLanguage = (lng) => {
    localStorage.setItem('language', lng)
    window.location.reload()
  }

  const handlePreview = () => {
    if (!accountObj?.domain_name) {
      raiseToast('error', 'Domain not found!')
      return
    }

    const url = accountObj?.domain_name.includes('http')
      ? accountObj?.domain_name
      : `http://${accountObj?.domain_name}`

    window.open(url, '_blank')
    return
  }

  return (
    <CHeader position="sticky" className="mb-2">
      <CContainer fluid>
        <CHeaderToggler
          className="ps-1"
          onClick={() => dispatch({ type: 'set', sidebarShow: !sidebarShow })}
        >
          <CIcon icon={cilMenu} size="lg" />
        </CHeaderToggler>
        <CHeaderBrand>{accountObj.name}</CHeaderBrand>
        <CHeaderNav className="d-none d-md-flex me-auto">
          <CNavItem />
        </CHeaderNav>
        <CHeaderNav className="">
          <CButton
            className="text-white  cursor-pointer w-100"
            onClick={handlePreview}
            style={{ background: '#20211c' }}
          >
            Preview Store
          </CButton>
        </CHeaderNav>
        <CHeaderNav className="ms-3">
          {!userObj?.is_super_user && accountObj?.allowed_languages?.length > 1 && (
            <CFormSelect
              value={language ? language : ''}
              onChange={(e) => changeLanguage(e.target.value)}
              className="mx-3"
              size="sm"
            >
              <option value="" disabled>
                Select Language
              </option>
              {!isEmpty(accountObj?.allowed_languages) &&
                accountObj.allowed_languages.map((info, index) => {
                  return (
                    <option value={info.code} key={index}>
                      {info.displayName}
                    </option>
                  )
                })}
            </CFormSelect>
          )}
          <AppHeaderDropdown />
        </CHeaderNav>
      </CContainer>
    </CHeader>
  )
}

export default AppHeader
